import Cookies from 'js-cookie'

import services from './config/services'

const STAGING_DOMAIN = 'tbt-staging.com'
const PRODUCTION_DOMAIN = 'theblacktux.com'

const getCookieDomain = () => {
  const isStagingDomain = !!window.location.hostname.match(STAGING_DOMAIN)
  const isProductionDomain =
    !!window.location.hostname.match(PRODUCTION_DOMAIN) &&
    !window.location.hostname.includes('local')

  if (isStagingDomain) {
    return STAGING_DOMAIN
  }
  if (isProductionDomain) {
    return PRODUCTION_DOMAIN
  }
  return ''
}

export const removeExistingJwt = () => {
  const oldJwt = Cookies.get(services.JWT_AUTH_COOKIE_NAME)
  if (oldJwt !== undefined) {
    Cookies.remove(services.JWT_AUTH_COOKIE_NAME, {domain: getCookieDomain()})
  }
}

const getDomainOpts = () => {
  // All preview environments point to tbt-staging.com
  // Extends the cookie to work across all tbt-staging.com subdomains, namely for the purposes of making Vercel fe-core PR Previews work.
  // All other domains are fine to be restricted to their respective domain.
  const isDevDomain = !!window.location.hostname.match(STAGING_DOMAIN)
  const isProductionDomain =
    !!window.location.hostname.match(PRODUCTION_DOMAIN) &&
    !window.location.hostname.includes('local')

  if (isDevDomain) {
    return {domain: '.tbt-staging.com'}
  }
  if (isProductionDomain) {
    return {domain: '.theblacktux.com'}
  }
  return {}
}

/**
 * Grabs the JWT from storage
 * @return {String|null}
 */
export const getJwt = () => Cookies.get(services.JWT_AUTH_COOKIE_NAME)

/**
 * Helper function to tell us if a user currently has a JWT
 * @return {Boolean}
 */
export const hasJwt = () => !!getJwt()

/**
 * The JWT must be set in a cookie to comply with certain server
 * API's that require it be sent as such.
 *
 * The expiration length of the cookie is misleading — the auth
 * service will invalidate the JWT sooner than that. When that
 * happens, the user is treated as "logged-out" and will have to
 * log back in, triggering a new JWT creation.
 *
 * The `setItem` call must be inside a `try`/`catch` block to prevent
 * errors when the storage is full, particular in iOS Safari
 *
 * @param {String} token The JSON Web Token to set
 *
 * @see [setItem](https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem)
 */
export const setJwt = (token) => {
  removeExistingJwt()
  Cookies.set(services.JWT_AUTH_COOKIE_NAME, token, {expires: 365, ...getDomainOpts()})
}

/**
 * Deletes any set JWT's in cookies and storage
 * @return {void}
 */
export const deleteJwt = () => {
  removeExistingJwt()
  Cookies.remove(services.JWT_AUTH_COOKIE_NAME, getDomainOpts())
}
